/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RequestLogDto {
  id?: number;
  requestId?: string;
  method?: string;
  path?: string;
  statusCode?: number | null;
  startedAt?: string;
  durationMs?: number | null;
  userId?: string | null;
  userEmail?: string | null;
  customerEmail?: string | null;
  paymentLinkId?: string | null;
  transactionId?: number | null;
  establishmentId?: number | null;
  posId?: string | null;
  clientId?: string | null;
  hasErrors?: boolean;
  logEntriesCount?: number;
}
